import api from '../api';
import {
  ISubjectsByClassroomResponse,
  IGetTeacherClassroomSubjectsResponse,
} from '../../interface/subjectModel';

export const fetchSubjectsByClassroomId = async (
  classroomId: string,
): Promise<ISubjectsByClassroomResponse> => {
  const response = await api.get<ISubjectsByClassroomResponse>(
    `/classroom/${classroomId}/subjects`,
  );
  return response.data;
};

/**
 * CVA-4153/4155 — subjects the CALLING teacher is rostered to teach in ONE
 * specific classroom (GET /me?type=subjects&classroomId=<id>). Backs the Add
 * Exam wizard's Teacher-scoped subject picker, populated the instant a
 * classroom is selected. Deliberately calls the `me` module's subjects
 * lookup rather than `/subject/user?classroomId=` — same underlying
 * `roster_detail` query, but this one already returns grade/curriculum names
 * alongside each subject, and it's the module already used elsewhere in the
 * exam feature (`GET /me?type=exam`) and by the classroom picker above.
 */
export const fetchTeacherClassroomSubjects = async (
  classroomId: string,
): Promise<IGetTeacherClassroomSubjectsResponse> => {
  const response = await api.get<IGetTeacherClassroomSubjectsResponse>('/me', {
    params: { type: 'subjects', classroomId },
  });
  return response.data;
};
